<template>
  <div>
    <el-row><el-col :offset="16"><h3>笔数：{{ cnt }}&nbsp;&nbsp;充值金额：{{ totalCharge }}&nbsp;&nbsp;赠送金额：{{ totalGift }}</h3></el-col></el-row>
    <el-table
      v-loading="listLoading"
      :key="0"
      :data="alist"
      border
      fit
      highlight-current-row
      style="width: 100%;"
    >
      <el-table-column label="订单号" align="center" min-width="70px">
        <template slot-scope="scope">
          <span>{{ scope.row.id }}</span>
        </template>
      </el-table-column>
      <el-table-column label="会员ID" align="center" min-width="100px">
        <template slot-scope="scope">
          <span>{{ scope.row.memberId | memberIdFilter }}</span>
        </template>
      </el-table-column>
      <el-table-column label="会员姓名" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.memberName | blankFilter }}</span>
        </template>
      </el-table-column>
      <el-table-column label="会员卡号" align="center" min-width="90px">
        <template slot-scope="scope">
          <span>{{ scope.row.memberCardNo | cardFilter }}</span>
        </template>
      </el-table-column>
      <el-table-column label="车牌号" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.memberCarNo | blankFilter }}</span>
        </template>
      </el-table-column>
      <el-table-column label="车队名称" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.companyName | blankFilter }}</span>
        </template>
      </el-table-column>
      <el-table-column label="账户类型" align="center" min-width="95px">
        <template slot-scope="scope">
          <span>{{ scope.row.memberType | accountTypeFilter }}</span>
        </template>
      </el-table-column>
      <el-table-column label="金额" align="center" min-width="100px">
        <template slot-scope="scope">
          <span>{{ scope.row.amt }}</span>
        </template>
      </el-table-column>
      <el-table-column label="赠送金额" align="center" min-width="80px">
        <template slot-scope="scope">
          <span>{{ scope.row.giftAmt }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('amount.balanceAmt')" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.balanceAmt }}</span>
        </template>
      </el-table-column>
      <el-table-column label="站点" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.optStationName }}</span>
        </template>
      </el-table-column>
      <el-table-column label="员工" align="center" min-width="90px">
        <template slot-scope="scope">
          <span>{{ scope.row.optEmpName }}</span>
        </template>
      </el-table-column>
<!--      <el-table-column label="班次号" align="center" min-width="120px">
        <template slot-scope="scope">
          <span>{{ scope.row.shiftNo }}</span>
        </template>
      </el-table-column>-->
      <el-table-column label="支付方式" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.payTypeName }}</span>
        </template>
      </el-table-column>
      <el-table-column label="班次号" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.classes }}</span>
        </template>
      </el-table-column>
      <el-table-column label="充值时间" align="center" min-width="155px">
        <template slot-scope="scope">
          <span>{{ scope.row.createdTime }}</span>
        </template>
      </el-table-column>
      <el-table-column label="备注" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.memo | blankFilter }}</span>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  name: 'Charge',
  filters: {
    blankFilter (val) {
      if (!val && val !== 0 || val === 'null' || val === 'undefined') {
        return ''
      } else {
        return val
      }
    },
    cardFilter (val) {
      if (!val) {
        return '-'
      } else {
        return val
      }
    },
    memberIdFilter (memberId) {
      if (memberId <= 0) {
        return '-'
      } else {
        return memberId
      }
    },
    accountTypeFilter (type) {
      switch (type) {
        case 1:
          return '散户'
        case 2:
          return '车队子账户'
        case 3:
          return '车队总账户'
        default:
          return ''
      }
    }
  },
  props: {
    alist: {
      type: Array,
      required: true,
      twoWay: true
    },
    listLoading: {
      type: Boolean,
      required: true,
      twoWay: true
    },
    totalCharge: {
      type: Number,
      required: true,
      twoWay: true
    },
    cnt: {
      type: Number,
      required: true,
      twoWay: true
    },
    totalGift: {
      type: Number,
      required: true,
      twoWay: true
    }
  }
}
</script>

